/* import __COLOCATED_TEMPLATE__ from './modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';
interface Signature {
  Args: {
    isOpen: boolean;
    onModalClose: (object: string) => void;
  };
}

const FinGuaranteeModal = templateOnlyComponent<Signature>();
export default FinGuaranteeModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinGuarantee::Modal': typeof FinGuaranteeModal;
    'fin-guarantee/modal': typeof FinGuaranteeModal;
  }
}
